var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88547 4.97837C8.68934 4.78398 8.37276 4.78539 8.17837 4.98152C7.98398 5.17765 7.98539 5.49423 8.18152 5.68862L9.12177 6.62052C9.50504 7.00038 9.76194 7.25607 9.93468 7.47115C9.9426 7.48102 9.95025 7.49068 9.95763 7.50016L5.3335 7.50016C5.05735 7.50016 4.8335 7.72402 4.8335 8.00016C4.8335 8.27631 5.05735 8.50016 5.3335 8.50016L9.95764 8.50016C9.95025 8.50964 9.9426 8.51931 9.93468 8.52917C9.76194 8.74425 9.50504 8.99994 9.12177 9.3798L8.18152 10.3117C7.98539 10.5061 7.98398 10.8227 8.17837 11.0188C8.37276 11.2149 8.68934 11.2163 8.88547 11.022L9.84624 10.0697C10.2037 9.71547 10.5018 9.42001 10.7144 9.15533C10.9373 8.87772 11.1069 8.58596 11.1522 8.23049C11.162 8.15403 11.1668 8.0771 11.1668 8.00016C11.1668 7.92323 11.162 7.8463 11.1522 7.76983C11.1069 7.41437 10.9373 7.12261 10.7144 6.84499C10.5018 6.58032 10.2037 6.28486 9.84625 5.93062L8.88547 4.97837Z",
    fill: "#1573FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496ZM1.8335 8.00016C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowOutlined);
export default __webpack_public_path__ + "static/media/RightArrowOutlined.1cfb5388d04392f4ebfd74c02445b18a.svg";
export { ForwardRef as ReactComponent };